export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/front/reserve',
      name: 'distributor-tour-front-reserve',
      component: () => import('./index.vue'),
    },
  ]
};
